import Link from '@a24/ui/Link'
import SanityImage from '@a24/ui/SanityImage'
import { format } from 'date-fns/format'
import type { SanityCartPerformance } from './type'
const CartShowCard = ({
  className,
  performanceData
}: { className?: string; performanceData?: SanityCartPerformance }) => {
  if (!performanceData)
    return <div className='title-md text-heritage-red-full'>Performance</div>
  return (
    <div className={className}>
      <div className='flex justify-start gap-3'>
        <SanityImage
          sanityImageSourceData={
            'parentShow' in performanceData
              ? performanceData.parentShow?.page?.image
              : performanceData.parentProduct?.page?.image
          }
          width={80}
          height={128}
          className='min-w-20 w-20 h-32 rounded'
          imageClassName='rounded'
        />
        <div>
          {'startDate' in performanceData && (
            <p className='body-xs mb-2'>
              {format(
                new Date(performanceData.startDate),
                'LLL d · E · h:mm b'
              )}
            </p>
          )}
          <Link
            href={`/${
              'parentShow' in performanceData
                ? performanceData.parentShow.page.path
                : performanceData.parentProduct.page.path
            }`}
            className='title-md text-heritage-red-full cursor-pointer'
          >
            {'parentShow' in performanceData
              ? performanceData.parentShow.name
              : performanceData.parentProduct.name}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default CartShowCard
